/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  categories: Array < any > ;
  operator: string;
  products: Array < any > ;
  skus ? : Array < any > ;
}
export interface multiStruct {
  name ? : string;
  value ? : Array < any > ;
}
export default interface ProductList {
  title ? : string;
  titleColor ? : number;
  headingTag ? : string;
  showFilter ? : boolean;
  switchable ? : switchableStruct;
  sale ? : boolean;
  new ? : boolean;
  mykik ? : boolean;
  productAttributes ? : string;
  multi ? : Array < multiStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  title: String,
  titleColor: Number,
  headingTag: String,
  showFilter: Boolean,
  switchable: Object as() => switchableStruct,
  sale: Boolean,
  new: Boolean,
  mykik: Boolean,
  productAttributes: String,
  multi: Array as() => Array < multiStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  title: String,
  titleColor: Number,
  headingTag: String,
  showFilter: Boolean,
  switchable: Object as() => switchableStruct,
  sale: Boolean,
  new: Boolean,
  mykik: Boolean,
  productAttributes: String,
  multi: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class ProductListBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class ProductListInstance implements ProductList {
      title ? : string;
      titleColor ? : number;
      headingTag ? : string;
      showFilter ? : boolean;
      switchable ? : switchableStruct;
      sale ? : boolean;
      new ? : boolean;
      mykik ? : boolean;
      productAttributes ? : string;
      multi ? : Array < multiStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.multi) {
          this.multi = Object.entries(this.multi)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'multi' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.multi = null as any;
        }
      }
    }
    return new ProductListInstance(props);
  }
}
